import { render, staticRenderFns } from "./StadiumCreateForm.vue?vue&type=template&id=51ccad3d&"
import script from "./StadiumCreateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ccad3d')) {
      api.createRecord('51ccad3d', component.options)
    } else {
      api.reload('51ccad3d', component.options)
    }
    module.hot.accept("./StadiumCreateForm.vue?vue&type=template&id=51ccad3d&", function () {
      api.rerender('51ccad3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StadiumCreateForm.vue"
export default component.exports